import { Control } from "../flatbuffers/generated/control/control";
import { ActionInterface } from "../interfaces/Actions.interface";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_ACTION: ActionInterface = {
  id: "",
  message_enum: 0,
  lift_type: "ELEVATOR",
  target_position: 0,
  label: "",
  valid_states: [],
  tooltip: "",
};

// ELEVATOR_CONTROLS is derived from the generated FlatBuffer Control
// enum so a schema edit (e.g. adding/removing/renumbering a Control
// variant in flatbuffer_schemas/schemas/ln2/control.fbs) propagates
// automatically. A previous hand-rolled copy went stale when the
// "Assigned Hall Call" entries moved from Control to Usage, causing
// the wizard to mislabel them as Control::... values. Sourcing from
// the generated enum eliminates that class of drift.
//
// TypeScript emits enums with both name->value and value->name
// reverse mappings on the same object; Object.entries returns both.
// Filtering to entries whose value is a number keeps only the
// canonical name->value pairs.
export const ELEVATOR_CONTROLS = Object.entries(Control)
  .filter(([, value]) => typeof value === "number")
  .map(([name, value]) => ({ name, id: value as number }));
